/* ============================================================
   Homepage "New collection" + "Best sellers": show the first 3 rows,
   then a "View more" button reveals the rest of the collection in place.
   3 rows = 6 on mobile (2-col) / 12 on desktop (4-col). The CSS handles the
   collapse (grid without .is-expanded); this only wires the button.
   ============================================================ */
(function () {
  'use strict';
  function visCount() { return window.matchMedia('(min-width: 769px)').matches ? 18 : 6; }

  function setup(sec) {
    var grid = sec.querySelector('.grid');
    if (!grid || grid.dataset.vm) return;
    // Only the wrapping-grid layout uses "View more". On the horizontal scroll-rail
    // (mobile_scrollable) the section already has its own scrollbar + "View all", so
    // don't add a second, out-of-place button.
    if (sec.querySelector('.grid-overflow-wrapper')) return;
    grid.dataset.vm = '1';
    var products = Array.prototype.filter.call(grid.children, function (el) {
      return el.classList.contains('grid__item') && !el.classList.contains('text-center');
    });
    var wrap = document.createElement('div');
    wrap.className = 'pviewmore-wrap';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pviewmore';
    btn.textContent = 'View more';
    wrap.appendChild(btn);
    (grid.parentNode || sec).appendChild(wrap);

    function update() {
      var more = !grid.classList.contains('is-expanded') && products.length > visCount();
      wrap.style.display = more ? '' : 'none';
    }
    btn.addEventListener('click', function () { grid.classList.add('is-expanded'); update(); });
    update();
    window.addEventListener('resize', update);
  }

  function init() {
    document.querySelectorAll('[id$="__new-drop"], [id$="__bestsellers"]').forEach(setup);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
